module.exports = __webpack_public_path__ + "static/media/tools.3e5e6b5d.jpeg";